/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const agencyJobsRoutes = {
  path: '/agency-jobs',
  component: Layout,
  redirect: '/agency-jobs/list',
  name: 'AgencyJobs',
  meta: {
    title: 'Oferty pracy',
    icon: 'el-icon-suitcase',
    permissions: ['view menu administrator'],
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/agency-jobs/List'),
      name: 'AgencyJobsList',
      meta: { title: 'Lista ofert pracy', noCache: true, icon: 'el-icon-suitcase' },
    },
  ],
};

export default agencyJobsRoutes;
